export default "__VITE_ASSET__32d7ceca__"